import { LabCanvas3D } from './LabCanvas3D';
import { type ElectrolysisSceneState, createElectrolysisScene } from './electrolysisScene';

/** Real-world view of the Faraday Explore: the electrolysis cell, driven by the same result as the worked steps. */
export function Electrolysis3D({ state, playing, label }: { state: ElectrolysisSceneState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createElectrolysisScene} state={state} playing={playing} label={label} hint="Drag to turn the cell" />;
}
